import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { StoreClosure } from '../../../classes/models/store/StoreClosure';
import { AddStoreClosureRequest, EditStoreClosureRequest } from '../../../interfaces/request/StoreRequests';

/**
 * This service communicates with backend to handle store closure data management.
 */
@Injectable({
  providedIn: 'root'
})
export class StoreClosureService {
  private http = inject(HttpClient);

  url = environment.apiUrl + '/stores';

  /**
   * Adds a new date when the store is closed.
   * @param storeId an identifier of a store.
   * @param storeClosure the date and reason, why a store is closed.
   */
  addStoreClosure(storeId: string, storeClosure: StoreClosure) {
    const url = `${this.url}/${storeId}/closures`;
    const requestBody: AddStoreClosureRequest = { date: storeClosure.startDate, reason: storeClosure.reason, };
    return this.http.post(url, requestBody);
  }

  /**
   * Edits the date when the store is closed.
   * @param storeId an identifier of a store.
   * @param storeClosure the date and reason, why a store is closed.
   */
  editStoreClosure(storeId: string, storeClosure: StoreClosure) {
    const url = `${this.url}/${storeId}/closures/${storeClosure.startDate}`;
    const requestBody: EditStoreClosureRequest = { reason: storeClosure.reason, };
    return this.http.put(url, requestBody);
  }

  /**
   * Deletes the date, on which the store is closed.
   * @param storeId an identifier of a store.
   * @param date store closure date to be deleted.
   */
  deleteStoreClosure(storeId: string, date: string) {
    const url = `${this.url}/${storeId}/closures/${date}`;
    return this.http.delete(url);
  }
}
